import type { OrderPaymentState, StoreOrderSummary } from '@/types'

// Partial payments: the backend's payment_state, or the same rule from is_paid / paid_amount for
// responses that don't carry it.
export const resolveOrderPaymentState = (
  order: Pick<StoreOrderSummary, 'payment_state' | 'is_paid' | 'paid_amount'>,
): OrderPaymentState => {
  if (order.payment_state) return order.payment_state
  if (order.is_paid) return 'paid'
  return Number(order.paid_amount ?? 0) > 0 ? 'partially_paid' : 'unpaid'
}

export const ORDER_PAYMENT_STATE_LABELS: Record<OrderPaymentState, string> = {
  unpaid: 'Unpaid',
  partially_paid: 'Partially paid',
  paid: 'Paid',
}

export const ORDER_PAYMENT_STATE_BADGE_CLASSES: Record<OrderPaymentState, string> = {
  unpaid: 'border-rose-200 bg-rose-50 text-rose-700',
  partially_paid: 'border-amber-200 bg-amber-50 text-amber-700',
  paid: 'border-emerald-200 bg-emerald-50 text-emerald-700',
}

// The balance due from the backend's 400 when a partially paid booking is moved to Shipped /
// Delivered (more_info: { balance_due, payment_state: 'partially_paid' }); null for any other error.
export const getBalanceDueFromStatusError = (error: unknown): string | null => {
  const response = (error as { response?: { status?: number; data?: { more_info?: { balance_due?: unknown; payment_state?: unknown } } } })
    ?.response
  if (response?.status !== 400) return null
  const info = response.data?.more_info
  return info?.payment_state === 'partially_paid' && info.balance_due != null ? String(info.balance_due) : null
}
